
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
  name: 'InputCheck',
  emits: ['update:modelValue'],
  props: {
    modelValue: Boolean,
    isSwitch: Boolean,
    disabled: Boolean
  },
  setup(props, { emit }) {   
    const state = ref(props.modelValue)
    watch(() => props.modelValue, (newValue) => {
      state.value = newValue
    })
    function check() {      
      state.value = !state.value
      emit('update:modelValue', Boolean(state.value))
    }
    return { check, state }
  }
})
